(function(){
  if (customElements.get('cyq-gallery')) return;
  function $(s,c){return (c||document).querySelector(s);}
  function $all(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}

  customElements.define('cyq-gallery', class extends HTMLElement{
    connectedCallback(){
      var track=$('[data-track]',this),count=$('[data-count]',this),slides=$all('.cyqml__slide',this);
      if(track && slides.length>1){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){
          var i=slides.indexOf(e.target);count.textContent=(i+1)+' / '+slides.length;}});},{root:track,threshold:0.6});
        slides.forEach(function(s){io.observe(s);});
      }
      var zoom=$('cyq-zoom'),zimg=$('[data-zoom-img]'),open=$('[data-zoom-open]',this);
      function openZoom(){
        var cur=Math.round(track.scrollLeft/track.clientWidth);
        var sl=slides[cur]||slides[0];
        zimg.src=sl.getAttribute('data-zoom-src')||sl.querySelector('img').src;
        zoom.setAttribute('open','');document.body.style.overflow='hidden';
      }
      if(open) open.addEventListener('click',openZoom);
      slides.forEach(function(s){s.addEventListener('click',openZoom);});
    }
  });

  customElements.define('cyq-zoom', class extends HTMLElement{
    connectedCallback(){
      var self=this,close=$('.zclose',this);
      function c(){self.removeAttribute('open');document.body.style.overflow='';}
      close.addEventListener('click',c);
      this.addEventListener('click',function(e){if(e.target===self)c();});
    }
  });

  customElements.define('cyq-accordion', class extends HTMLElement{
    connectedCallback(){
      var btn=$('[data-toggle]',this),self=this;
      if(!btn)return;
      btn.addEventListener('click',function(){
        if(self.hasAttribute('open')){self.removeAttribute('open');btn.setAttribute('aria-expanded','false');}
        else{self.setAttribute('open','');btn.setAttribute('aria-expanded','true');}
      });
    }
  });

  customElements.define('cyq-modal', class extends HTMLElement{
    connectedCallback(){
      var self=this,close=$('.mclose',this);
      function c(){self.removeAttribute('open');document.body.style.overflow='';}
      function o(){self.setAttribute('open','');document.body.style.overflow='hidden';}
      if(close)close.addEventListener('click',c);
      this.addEventListener('click',function(e){if(e.target===self)c();});
      $all('[data-modal-open]').forEach(function(b){b.addEventListener('click',o);});
    }
  });

  var STAR='<svg viewBox="0 0 24 24"><path d="M12 2l3 6.5 7 .6-5.3 4.6 1.6 6.8L12 17l-6.9 3.5 1.6-6.8L1.4 9.1l7-.6z"/></svg>';
  var STAR0='<svg viewBox="0 0 24 24" style="fill:#dcdcdc"><path d="M12 2l3 6.5 7 .6-5.3 4.6 1.6 6.8L12 17l-6.9 3.5 1.6-6.8L1.4 9.1l7-.6z"/></svg>';
  function starRow(n){var s='';for(var i=1;i<=5;i++){s+=(i<=Math.round(n)?STAR:STAR0);}return s;}
  function esc(t){var d=document.createElement('div');d.textContent=(t==null?'':t);return d.innerHTML;}
  function readJSON(id){var el=document.getElementById(id);if(!el)return null;try{return JSON.parse(el.textContent);}catch(e){return null;}}
  function relDate(iso){
    try{var d=new Date(String(iso).replace(' ','T'));var diff=(Date.now()-d.getTime())/86400000;
      if(diff<1)return 'Hoy';if(diff<2)return 'Ayer';
      if(diff<30)return 'Hace '+Math.floor(diff)+' días';
      var m=Math.floor(diff/30);if(m<12)return 'Hace '+m+(m===1?' mes':' meses');
      var y=Math.floor(diff/365);return 'Hace '+y+(y===1?' año':' años');
    }catch(e){return '';}
  }

  customElements.define('cyq-reviews', class extends HTMLElement{
    connectedCallback(){
      var self=this,close=$('[data-reviews-close]',this);
      function o(){self.setAttribute('open','');document.body.style.overflow='hidden';}
      function c(){self.removeAttribute('open');document.body.style.overflow='';}
      if(close)close.addEventListener('click',c);
      $all('[data-reviews-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();o();});});
      this.renderRevie();
    }
    renderRevie(){
      var mounts=$all('[data-revie-mount]');if(!mounts.length)return;
      var data=readJSON('cyq-revie-data')||{},list=readJSON('cyq-revie-list')||[];
      var count=data.reviewCount||list.length||0,avg=data.reviewAverageValue||0;
      function build(limit){
        if(!count){return '<p style="color:#888;font-size:15px;padding:8px 0">Aún no hay opiniones de este producto.</p>';}
        var h='';
        h+='<div class="cyqml__ophead"><span class="cyqml__opbig">'+(Math.round(avg*10)/10).toFixed(1)+'</span><span class="cyqml__opstars">'+starRow(avg)+'</span></div>';
        h+='<div class="cyqml__opcount">'+count+' calificaciones</div>';
        var dist=data.stars||[];
        if(dist.length){
          h+='<div class="cyqml__opdist">';
          for(var s=5;s>=1;s--){var f=0;dist.forEach(function(x){if(parseInt(x.star,10)===s)f=x.count;});var pct=count?Math.round(f*100/count):0;
            h+='<div class="distrow"><span class="dl">'+s+'</span><span class="db"><i style="width:'+pct+'%"></i></span><span class="dn">'+f+'</span></div>';}
          h+='</div>';
        }
        var wi=list.filter(function(r){return r.images&&r.images.length;});
        if(wi.length){
          h+='<div class="cyqml__opfotostit">Opiniones con fotos</div><div class="cyqml__opfotos">';
          wi.slice(0,12).forEach(function(r){h+='<div class="cyqml__opfoto"><img src="'+r.images[0].src+'" alt="Opinión con foto" loading="lazy"><span class="opr">'+STAR+' '+(r.stars||5)+'</span></div>';});
          h+='</div>';
        }
        var rl=(limit&&limit>0)?list.slice(0,limit):list;
        rl.forEach(function(r){
          var fn=(r.customer&&r.customer.firstName)||'Cliente';
          var ln=(r.customer&&r.customer.lastName)?(' '+r.customer.lastName.charAt(0)+'.'):'';
          var yr='';try{yr=new Date(String(r.createdAt).replace(' ','T')).getFullYear()||'';}catch(e){}
          h+='<div class="cyqml__review"><span class="rdate">'+yr+'</span><span class="rstars">'+starRow(r.stars||5)+'</span>';
          h+='<div class="rname">'+esc(fn+ln)+'</div><p>'+esc(r.comment)+'</p>';
          if(r.images&&r.images.length){h+='<div class="rimgs">';r.images.forEach(function(im){h+='<img src="'+im.src+'" loading="lazy" alt="">';});h+='</div>';}
          if(r.commentResponse){h+='<div class="rresp"><b>Respuesta de Casa y Quincho:</b> '+esc(r.commentResponse)+'</div>';}
          h+='</div>';
        });
        return h;
      }
      mounts.forEach(function(m){
        var lim=m.hasAttribute('data-revie-inline')?4:0;
        m.innerHTML=build(lim);
      });
    }
  });

  customElements.define('cyq-qty', class extends HTMLElement{
    connectedCallback(){
      var inp=$('[data-qty]',this),minus=$('[data-minus]',this),plus=$('[data-plus]',this);
      function upd(){var n=parseInt(inp.value,10)||1;if(n<1)n=1;inp.value=n;minus.disabled=(n<=1);}
      minus.addEventListener('click',function(){inp.value=(parseInt(inp.value,10)||1)-1;upd();});
      plus.addEventListener('click',function(){inp.value=(parseInt(inp.value,10)||1)+1;upd();});
      upd();
    }
  });

  function toast(m){var t=document.createElement('div');t.className='cyqml-toast';t.textContent=m;
    document.body.appendChild(t);requestAnimationFrame(function(){t.classList.add('show');});
    setTimeout(function(){t.classList.remove('show');setTimeout(function(){t.remove();},300);},2200);}

  function addToCart(variantId,qty,opts){
    opts=opts||{};
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(variantId,10),quantity:qty||1}]})})
      .then(function(r){if(!r.ok)return r.json().then(function(e){throw e;});return r.json();})
      .then(function(data){
        try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'add_to_cart',ecommerce:{items:[{item_id:variantId,quantity:qty||1}]}});}catch(e){}
        if(opts.checkout){window.location.href='/checkout';return;}
        refreshAndOpenCart();
      })
      .catch(function(){toast('No se pudo agregar. Intenta de nuevo.');});
  }

  // Refresca el cart drawer del tema (Krown/Maestrooo) y lo abre
  function openCartSidebar(){
    var handle=$('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]');
    if(handle){handle.click();return true;}
    return false;
  }
  function refreshAndOpenCart(){
    fetch('?section_id=helper-cart').then(function(r){return r.text();}).then(function(text){
      var doc=new DOMParser().parseFromString(text,'text/html');
      var nf=doc.getElementById('AjaxCartForm'),ns=doc.getElementById('AjaxCartSubtotal');
      var cf=document.getElementById('AjaxCartForm'),cs=document.getElementById('AjaxCartSubtotal');
      if(nf&&cf){cf.innerHTML=nf.innerHTML;if(typeof cf.ajaxifyCartItems==='function'){try{cf.ajaxifyCartItems();}catch(e){}}}
      if(ns&&cs)cs.innerHTML=ns.innerHTML;
      var nc=doc.querySelector('[data-cart-count]'),nt=doc.querySelector('[data-cart-total]');
      if(nc)$all('[data-header-cart-count]').forEach(function(e){e.textContent=nc.textContent;});
      if(nt)$all('[data-header-cart-total]').forEach(function(e){e.textContent=nt.textContent;});
      var sb=document.getElementById('site-cart-sidebar');if(sb)sb.classList.remove('cart-is-empty');
      if(!openCartSidebar())toast('✓ Agregado al carrito');
    }).catch(function(){if(!openCartSidebar())toast('✓ Agregado al carrito');});
  }

  customElements.define('cyq-atc', class extends HTMLElement{
    connectedCallback(){
      var self=this,vid=this.getAttribute('data-variant');
      var qtyInput=$('[data-qty]');
      var add=$('[data-add]',this),buy=$('[data-buy]',this);
      function qty(){return qtyInput?(parseInt(qtyInput.value,10)||1):1;}
      if(add)add.addEventListener('click',function(){addToCart(vid,qty());});
      if(buy)buy.addEventListener('click',function(){addToCart(vid,qty(),{checkout:true});});
    }
  });

  // Barra sticky de compra
  customElements.define('cyq-sticky', class extends HTMLElement{
    connectedCallback(){
      var self=this,vid=this.getAttribute('data-variant');
      var qtyInput=$('[data-qty]');
      var buy=$('[data-sticky-buy]',this);
      if(buy)buy.addEventListener('click',function(){addToCart(vid,qtyInput?(parseInt(qtyInput.value,10)||1):1,{checkout:true});});
      var atc=$('cyq-atc');
      if(atc && 'IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){
          if(e.isIntersecting){self.classList.remove('show');}else{self.classList.add('show');}
        });},{threshold:0});
        io.observe(atc);
      }else{self.classList.add('show');}
    }
  });

  // "Siempre van juntos": barajar (random) + botones +
  var strip=$('[data-strip]');
  if(strip){
    var cards=$all('.cyqml__pcard',strip);
    for(var i=cards.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=cards[i];cards[i]=cards[j];cards[j]=t;}
    cards.forEach(function(c){strip.appendChild(c);});
  }
  $all('[data-add-variant]').forEach(function(b){
    b.addEventListener('click',function(e){e.preventDefault();addToCart(b.getAttribute('data-add-variant'),1);});
  });
})();

/* ── NAVEGACION DE GALERIA (flechas + miniaturas) ─────────────────────────
   Casa y Quincho · 26-08-2026
   Problema que arregla: <cyq-gallery> tiene el riel scrollable pero CERO
   controles. En movil el swipe salva; en escritorio las fotos 2+ no existen.
   Afecta al 57,2% del catalogo (535 de 936 fichas tienen 3 o mas fotos).

   Es aditivo: NO toca el markup ni el CSS del tema, NO interfiere con el zoom.
   Para revertir: borrar este bloque completo.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  if (window.__cyqGalleryNav) return;   // guarda anti doble-init
  window.__cyqGalleryNav = true;

  var CSS = [
    '.cyqnav__btn{position:absolute;top:50%;transform:translateY(-50%);width:40px;height:40px;',
    'border-radius:50%;background:#ffffffeb;box-shadow:0 1px 4px #0000001f;border:0;cursor:pointer;',
    'display:none;align-items:center;justify-content:center;z-index:3;padding:0;transition:opacity .15s}',
    '.cyqnav__btn svg{width:20px;height:20px;fill:none;stroke:#333;stroke-width:2.2;',
    'stroke-linecap:round;stroke-linejoin:round}',
    '.cyqnav__btn[disabled]{opacity:.35;cursor:default}',
    '.cyqnav__prev{left:12px}.cyqnav__next{right:12px}',
    /* solo en dispositivos con mouse: en tactil el swipe ya funciona */
    '@media (pointer:fine){.cyqnav__btn{display:flex}}',
    '.cyqnav__thumbs{display:flex;gap:8px;overflow-x:auto;padding:10px 2px 2px;',
    'scrollbar-width:none}',
    '.cyqnav__thumbs::-webkit-scrollbar{display:none}',
    '.cyqnav__thumb{flex:0 0 62px;width:62px;height:62px;border:2px solid transparent;',
    'border-radius:8px;overflow:hidden;background:#fff;cursor:pointer;padding:0;',
    'transition:border-color .15s}',
    '.cyqnav__thumb img{width:100%;height:100%;object-fit:contain;display:block}',
    '.cyqnav__thumb[aria-current="true"]{border-color:#c8440a}',
    '@media (max-width:749px){.cyqnav__thumbs{display:none}}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('cyqnav-css')) return;
    var s = document.createElement('style');
    s.id = 'cyqnav-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cyqnav__btn cyqnav__' + (dir < 0 ? 'prev' : 'next');
    b.setAttribute('aria-label', dir < 0 ? 'Foto anterior' : 'Foto siguiente');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="' +
      (dir < 0 ? '15 18 9 12 15 6' : '9 18 15 12 9 6') + '"/></svg>';
    return b;
  }

  // el src de Shopify YA trae width=900: hay que REEMPLAZARLO, no agregar otro
  function thumbSrc(src) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '124');
      return u.toString();
    } catch (e) { return src; }
  }

  function init(gal) {
    if (gal.__cyqnav) return;
    var track  = gal.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('.cyqml__slide'));
    if (!track || slides.length < 2) return;   // 1 sola foto: no hay que navegar
    gal.__cyqnav = true;

    injectCSS();

    var box = gal.querySelector('.cyqml__gallery') || gal;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';

    var prev = arrow(-1), next = arrow(1);
    box.appendChild(prev);
    box.appendChild(next);

    // ── miniaturas ──────────────────────────────────────────────────────
    var thumbs = document.createElement('div');
    thumbs.className = 'cyqnav__thumbs';
    slides.forEach(function (sl, i) {
      var img = sl.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cyqnav__thumb';
      b.setAttribute('aria-label', 'Ver foto ' + (i + 1) + ' de ' + slides.length);
      var t = document.createElement('img');
      t.loading = 'lazy';
      t.alt = '';
      t.src = thumbSrc(img && (img.currentSrc || img.src));
      b.appendChild(t);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();          // que no dispare el zoom del slide
        goTo(i);
      });
      thumbs.appendChild(b);
    });
    gal.appendChild(thumbs);
    var tbs = Array.prototype.slice.call(thumbs.children);

    // ── posicion por offsetLeft del slide: no depende de clientWidth ────
    function curIndex() {
      var best = 0, bd = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - track.scrollLeft);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }

    // OJO: nada de scrollTo({behavior:'smooth'}) aca. Probado en vivo el 26-ago:
    // con behavior smooth el riel NO se movia (scrollLeft se quedaba en 0).
    // La asignacion directa funciona en todas las condiciones probadas.
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollLeft = slides[i].offsetLeft;
      sync();
    }

    function sync() {
      var i = curIndex();
      prev.disabled = i <= 0;
      next.disabled = i >= slides.length - 1;
      tbs.forEach(function (b, k) {
        b.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }

    function go(dir) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();          // que no dispare el zoom del slide
        goTo(curIndex() + dir);
      };
    }
    prev.addEventListener('click', go(-1));
    next.addEventListener('click', go(1));

    var t = null;
    track.addEventListener('scroll', function () {
      if (t) return;
      t = setTimeout(function () { t = null; sync(); }, 90);
    }, { passive: true });
    window.addEventListener('resize', sync);

    // teclado: flechas izquierda/derecha cuando la galeria tiene el foco
    box.setAttribute('tabindex', box.getAttribute('tabindex') || '0');
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { go(-1)(e); }
      if (e.key === 'ArrowRight') { go(1)(e); }
    });

    sync();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('cyq-gallery')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // por si la ficha se re-renderiza al cambiar de variante
  document.addEventListener('shopify:section:load', boot);
})();